import module from '@app/ui/module'
import template from './template.html'
import './style.scss'

export class AppUiProductionComponent {
  constructor ($element, $scope, $window) {
    this.$scope = $scope
    this.$window = $window
    this.href = undefined
  }

  $onInit () {
    this.$scope.$on('$locationChangeSuccess', () => (this.getLocation()))
    this.getLocation()
  }

  getLocation () {
    this.href = this.$window.location.href.replace('http://localhost:83', 'https://admin.gnh.mx')
  }
}

module.component('appUiProduction', {
  controller: AppUiProductionComponent,
  template: template,
})



// WEBPACK FOOTER //
// ./src/app/ui/components/production/component.js